import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-about-one',
  templateUrl: './about-one.component.html',
  styleUrls: ['./about-one.component.scss']
})
export class AboutOneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
